<template>
  <button
    type="button"
    class="btn btn-gray-300 d-flex text-center font-weight-normal border-0"
    :class="getClass"
    style="min-height:55px; border-radius:45px"
    @click="$emit('on-click-btn')"
  >
    <div class="px-2 w-100 d-flex flex-row justify-content-between my-auto">
      <div>
        <slot>
          <div
            class="d-flex align-items-center text-start"
            :class=" `${info === '' ? '' : 'mb-1' }`"
          >
            {{ name }}
          </div>
          <div class="d-flex text-gray-600 align-items-center fs-14">
            {{ info }}
          </div>
        </slot>
      </div>
      <template v-if="haveIcon">
        <font-awesome-icon
          :icon="icon"
          class="my-auto"
          :class="selected ? 'text-primary' : ''"
          style="width:16px; height: 16px"
          @click.stop="$emit('on-click-icon')"
        />
      </template>
    </div>
  </button>
</template>

<script>

export default {
  name: 'SelectorBasic',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    info: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: [String, Array],
      required: false,
      default: () => ['fas', 'long-arrow-alt-right'],
    },
    haveIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getClass() {
      const classes = [];
      if (this.selected) {
        classes.push('active');
      }
      if (this.disabled) {
        classes.push('disabled');
      }
      return classes.join` `;
    },
  },
};
</script>
